const PROJECT_PRIVILEGES = {
  PROJECT_CREATE: 'project_create',
  PROJECT_UPDATE: 'project_update',

  PROJECT_PAYMENTTRACKER_INSTALLMENT_UPDATE:
    'project_payment_tracker_installment_update',
  PROJECT_PAYMENTTRACKER_PARTPAYMENT_CREATE:
    'project_payment_tracker_part_payment_create',
  PROJECT_PAYMENTTRACKER_PARTPAYMENT_UPDATE:
    'project_payment_tracker_part_payment_update',
  PROJECT_PAYMENTTRACKER_VIEW: 'project_payment_tracker_view',

  PROJECT_TASK_CREATE: 'project_task_create',
  PROJECT_TASK_VIEW: 'project_task_view',
  PROJECT_TASK_DETAILS_VIEW: 'project_task_details_view',
  PROJECT_TASK_UPDATE: 'project_task_update',
  PROJECT_TASK_DELETE: 'project_task_delete',

  PROJECT_FILES_DRAG_AND_DROP_MANAGE: 'project_files_drag_and_drop_manage',
  PROJECT_FILES_SAVE: 'project_files_save',
  PROJECT_FILES_VIEW: 'project_files_view',

  PROJECT_MI_VIEW: 'project_mi_view',
  PROJECT_MI_DETAILS_VIEW: 'project_mi_details_view',
  PROJECT_MI_CREATE: 'project_mi_create',
  PROJECT_MI_UPDATE: 'project_mi_update',
  PROJECT_MI_CLONE: 'project_mi_clone',

  PROJECT_PO_VIEW: 'project_po_view',
  PROJECT_PO_DETAILS_VIEW: 'project_po_details_view',
  PROJECT_PO_CREATE: 'project_po_create',
  PROJECT_PO_UPDATE: 'project_po_update',
  PROJECT_PO_CLONE: 'project_po_clone',
  PROJECT_PO_DELETE: 'project_po_delete',

  PROJECT_STOCKS_LOGS_VIEW: 'project_stocks_logs_view',
  PROJECT_STOCKS_STAR: 'project_stocks_star',
  PROJECT_STOCKS_UPDATE: 'project_stocks_update',
  PROJECT_STOCKS_UPDATE_USED_WASTE: 'project_stocks_update_usedWaste',
  PROJECT_STOCKS_UPDATE_SUBSTOCK: 'project_stocks_update_substock',
  PROJECT_STOCKS_UPDATE_SUBSTOCK_USED_WASTE:
    'project_stocks_update_substock_usedWaste',
  PROJECT_STOCKS_UPDATE_MIN_RECORD_QUANTITY:
    'project_stocks_update_minReOrderQuantity',

  PROJECT_LOGISTICS_VIEW: 'project_logistics_view',
  PROJECT_LOGISTICS_CREATE: 'project_logistics_create',
  PROJECT_LOGISTICS_DETAILS_VIEW: 'project_logistics_details_view',
  PROJECT_LOGISTICS_UPDATE: 'project_logistics_update',

  PROJECT_BOQ_VIEW: 'project_boq_view',
  PROJECT_BOQ_PROJECT_MATERIAL_ADD: 'project_boq_project_material_add',
  PROJECT_BOQ_PROJECT_MATERIAL_UPDATE: 'project_boq_project_material_update',
  PROJECT_BOQ_PROJECT_MATERIAL_DELETE: 'project_boq_project_material_delete',
  PROJECT_BOQ_TASK_MATERIAL_ADD: 'project_boq_task_material_add',
  PROJECT_BOQ_TASK_MATERIAL_UPDATE: 'project_boq_task_material_update',
  PROJECT_BOQ_TASK_MATERIAL_DELETE: 'project_boq_task_material_delete',

  OVERVIEW_VIEW: 'project_overview_view',
  PROJECT_DELETE: 'project_delete',
  PROJECT_DETAILS_VIEW: 'project_details_view',

  PROJECT_STOCKS_VIEW: 'project_stocks_view',
  PROJECT_PO_CONVERT_TO_BILL: 'project_po_convert_to_bill',

  PROJECT_PAYMENT_TRACKER_ADD_TASK: 'project_payment_tracker_add_task',
  PROJECT_TASK_MARK_AS_COMPLETE: 'project_task_mark_as_complete',

  PROJECT_FILES_DOWNLOAD: 'project_files_download',
  PROJECT_FILES_PREVIEW: 'project_files_preview',
  PROJECT_FILES_DELETE: 'project_files_delete',

  PROJECT_MI_EXPORT: 'project_mi_export',
  PROJECT_PO_EXPORT: 'project_po_export',

  PROJECT_STOCK_HOLD: 'project_stocks_hold',
  PROJECT_STOCK_EXPORT: 'project_stocks_export',

  PROJECT_LABOUR_PAYMENTS_VIEW: 'project_labour_payments_view',
  PROJECT_LABOUR_ASSIGN: 'project_labour_payment_assign_new_labour',
  // PROJECT_LABOUR_PAYMENTS_VIEW_ATTENDANCE:
  //   'project_labour_payment_labour_attendance',
    
  PROJECT_LABOUR_PAYMENT_DETAILS: 'project_labour_payment_details',
  PROJECT_LABOUR_PAYMENT_DETAIL_VIEW_EDIT:
    'project_labour_payment_detail_view_edit',
  PROJECT_LABOUR_PAYMENT_DETAIL_ADD_PART_PAYMENT:
    'project_labour_payment_detail_add_part_payment',
  PROJECT_LABOUR_PAYMENT_WORK_ORDER_ADD:
    'project_labour_payment_work_order_add',
  PROJECT_LABOUR_PAYMENT_WORK_ORDER_EDIT:
    'project_labour_payment_work_order_edit',
  PROJECT_LABOUR_PAYMENT_WORK_SUMMARY_EDIT:
    'project_labour_payment_work_summary_edit',
  PROJECT_LABOUR_PAYMENT_WORK_SUMMARY_ADD:
    'project_labour_payment_work_summary_add',

    //new
  UPDATE_PAYMENT_CYCLE: 'update_payment_cycle',
  PAYMENT_TRACKER_DELETE_PART_PAYMENT: 'payment_tracker_delete_part_payment',
  PROJECT_TASK_IMPORT_TASK: 'project_task_import_task',
  PROJECT_TASK_CREATE_SUB_TASK: 'project_task_create_sub_task',
  PROJECT_TASK_IMPORT_SUB_TASK: 'project_task_import_sub_task',
  PROJECT_TASK_DELETE_SUB_TASK: 'project_task_delete_sub_task',
  PROJECT_TASK_UPDATE_SUB_TASK: 'task_update_sub_task',  //common
  PROJECT_TASK_VIEW_SUB_TASK_DETAILS: 'task_view_sub_task_details',//common
  PROJECT_TASK_SUB_TASK_RAISE_ISSUE: 'task_sub_task_raise_issue', //common
  PROJECT_TASK_SUB_TASK_EDIT_ISSUE: 'task_sub_task_edit_issue', //common
  PROJECT_TASK_SUB_TASK_ADD_COMMENT: 'task_sub_task_add_comment', //common
  PROJECT_TASK_SUB_TASK_UPLOAD_FILE: 'task_sub_task_upload_file', //common
  PROJECT_TASK_SUB_TASK_DOWNLOAD_FILE: 'task_sub_task_download_file', //common
  PROJECT_TASK_SUB_TASK_DELETE_FILE: 'task_sub_task_delete_file', //common
  PROJECT_TASK_SUB_TASK_ADD_CHECKLIST: 'task_sub_task_add_checklist', //common
  PROJECT_TASK_SUB_TASK_EDIT_CHECKLIST: 'task_sub_task_edit_checklist', //common
  PROJECT_TASK_SUB_TASK_DELETE_CHECKLIST: 'task_sub_task_delete_checklist', //common
   PROJECT_TASK_ADD_CHECKLIST: 'project_task_add_checklist',
   PROJECT_TASK_UPDATE_CHECKLIST: 'project_task_update_checklist',
   PROJECT_TASK_DELETE_CHECKLIST: 'project_task_delete_checklist',
   PROJECT_TASK_RAISE_ISSUE: 'project_task_raise_issue',
   PROJECT_TASK_EDIT_ISSUE: 'project_task_edit_issue',
   PROJECT_TASK_UPLOAD_FILES: 'project_task_upload_files',
   PROJECT_TASK_VIEW_FILES: 'project_task_view_files',
   PROJECT_TASK_DOWNLOAD_FILES: 'project_task_download_files',
   PROJECT_TASK_DELETE_FILES: 'project_task_delete_files',
   PROJECT_TASK_ADD_COMMENT: 'project_task_add_comment',
   PROJECT_TASK_ADD_LABOUR_ATTENDANCE: 'project_task_add_labour_attendance',
   PROJECT_TASK_EDIT_LABOUR_ATTENDANCE: 'project_task_edit_labour_attendance',
   PROJECT_TASK_UPDATE_STOCK: 'project_task_update_stock',
   PROJECT_FILES_HIGHLIGHTER: 'project_files_highlighter',
   PROJECT_FILES_LINK_TASK: 'project_files_link_task',
   PROJECT_FILES_CREATE_FOLDER: 'project_files_create_folder',
   PROJECT_FILES_EDIT_FOLDER: 'project_files_edit_folder',
   PROJECT_FILES_DELETE_FOLDER: 'project_files_delete_folder',
  // PROJECT_FILES_FOLDER_CREATE_FOLDER: 'project_files_folder_create_folder', only one create folder
   PROJECT_FILES_FOLDER_SELECT_FILE: 'project_files_folder_select_file',
   PROJECT_FILES_FOLDER_PREVIEW_FILE: 'project_files_folder_preview_file',
   PROJECT_FILES_FOLDER_DOWNLOAD_FILE: 'project_files_folder_download_file',
   PROJECT_FILES_FOLDER_DELETE_FILE: 'project_files_folder_delete_file',
   PROJECT_MI_DISPATCH_INVENTORY: 'project_mi_dispatch_inventory',
   PROJECT_MI_DISPATCH_PO: 'project_mi_dispatch_po',
   PROJECT_MI_SEND_WHATSAPP: 'project_mi_send_whatsapp',
   PROJECT_MI_RECEIVE_NOTES: 'project_mi_receive_notes',
   PROJECT_MI_RETURN_EXCHANGE: 'project_mi_return_exchange',
   PROJECT_PO_CLIENT_PRICING: 'project_po_client_pricing',
   PROJECT_PO_RECEIVE_NOTES: 'project_po_receive_notes',
   PROJECT_PO_RETURN_EXCHANGE: 'project_po_return_exchange',
   PROJECT_PO_SEND_WHATSAPP: 'project_po_send_whatsapp',
   PROJECT_LOGISTICS_RECEIVE_NOTES: 'project_logistics_receive_notes',
   PROJECT_LABOUR_UPDATE_PAYMENT_CYCLE: 'project_labour_update_payment_cycle',
  //  PROJECT_LABOUR_PAYMENT_INSTALLMENT: 'project_labour_payment_installment', need to remove
   PROJECT_LABOUR_EDIT_PART_PAYMENT: 'project_labour_edit_part_payment',
   PROJECT_LABOUR_ATTENDANCE_VIEW: 'project_labour_attendance_view', 
   PROJECT_LABOUR_ATTENDANCE_ADD: 'project_labour_attendance_add',
   PROJECT_LABOUR_ATTENDANCE_EDIT: 'project_labour_attendance_edit',
   PROJECT_LABOUR_ATTENDANCE_MAJOR_WORK_DAY: 'project_labour_attendance_major_work_day',


};
const APPROVAL_PRIVILEGES = {
  MATERIAL_INDENT_LEVEL_1_APPROVAL: 'global_mi_level_1_approval',
  MATERIAL_INDENT_LEVEL_2_APPROVAL: 'global_mi_level_2_approval',
  MATERIAL_INDENT_LEVEL_3_APPROVAL: 'global_mi_level_3_approval',

  PURCHASE_ORDER_LEVEL_1_APPROVAL: 'global_po_level_1_approval',
  PURCHASE_ORDER_LEVEL_2_APPROVAL: 'global_po_level_2_approval',
  PURCHASE_ORDER_LEVEL_3_APPROVAL: 'global_po_level_3_approval',

  PURCHASE_ORDER_BILL_LEVEL_1_APPROVAL: 'global_po_bill_level_1_approval',
  PURCHASE_ORDER_BILL_LEVEL_2_APPROVAL: 'global_po_bill_level_2_approval',
  PURCHASE_ORDER_BILL_LEVEL_3_APPROVAL: 'global_po_bill_level_3_approval',
};
const COMMON_PRIVILEGES = {
  VEHICLE_DELETE: 'global_vehicle_delete',
  VEHICLE_UPDATE: 'global_vehicle_update',
  VEHICLE_VIEW: 'global_vehicle_view',
  VEHICLE_CREATE: 'global_vehicle_create',

  COMPANY_DETAILS_VIEW: 'global_company_details_view',
  COMPANY_DETAILS_CREATE: 'global_company_details_create',
  COMPANY_DETAILS_UPDATE: 'global_company_details_update',
  COMPANY_DETAILS_DELETE: 'global_company_details_delete',

  // CRM
  CRM_LEADS_PAGE_VIEW: 'crm_leads_page_view',
  CRM_LEADS_CREATE: 'crm_leads_create',
  CRM_LEADS_UPDATE: 'crm_leads_update',
  CRM_LEADS_DELETE: 'crm_leads_delete',
  CRM_ACTIVITY_PAGE_VIEW: 'crm_activity_page_view',
  CRM_FOLLOWUP_PAGE_VIEW: 'crm_followup_page_view',
  CRM_SETTINGS_PAGE_VIEW: 'crm_settings_page_view',

  // INTERNAL_PURCHASE_VIEW: 'internal_purchase_view',
  // INTERNAL_PURCHASE_DETAILS_VIEW: 'internal_purchase_details_view',
  // INTERNAL_PURCHASE_CREATE: 'internal_purchase_create',
  // INTERNAL_PURCHASE_DELETE: 'internal_purchase_delete',

  EMPLOYEES_VIEW: 'global_employees_view',
  EMPLOYEES_CREATE: 'global_employees_create',
  EMPLOYEES_UPDATE: 'global_employees_update',
  EMPLOYEES_DELETE: 'global_employees_delete',

  LABOURS_VIEW: 'global_labours_view',

  VENDORS_VIEW: 'global_vendors_view',
  VENDORS_CREATE: 'global_vendors_create',
  VENDORS_UPDATE: 'global_vendors_update',
  VENDORS_DELETE: 'global_vendors_delete',

  WAREHOUSE_VIEW: 'global_warehouse_view',
  WAREHOUSE_CREATE: 'global_warehouse_create',
  WAREHOUSE_UPDATE: 'global_warehouse_update',
  WAREHOUSE_DELETE: 'global_warehouse_delete',

  PO_BILLS_VIEW: 'global_po_bills_view',
  PO_BILLS_UPDATE: 'global_po_bills_update',
  PO_BILLS_DETAILS_VIEW: 'global_po_bills_details_view',

  PURCHASE_ORDER_VIEW: 'global_po_view',
  PURCHASE_ORDER_DETAILS_VIEW: 'global_po_details_view',
  PURCHASE_ORDER_CREATE: 'global_po_create',
  PURCHASE_ORDER_UPDATE: 'global_po_update',
  PURCHASE_ORDER_CLONE: 'global_po_clone',
  PURCHASE_ORDER_DELETE: 'global_po_delete',

  MATERIAL_INDENT_VIEW: 'global_mi_view',
  MATERIAL_INDENT_DETAILS_VIEW: 'global_mi_details_view',
  MATERIAL_INDENT_UPDATE: 'global_mi_update',
  MATERIAL_INDENT_CLONE: 'global_mi_clone',
  MATERIAL_INDENT_CREATE: 'global_mi_create',
  MATERIAL_INDENT_DELETE: 'global_mi_delete',

  GLOBAL_DASHBOARD_VIEW: 'global_dashboard_view',

  GLOBAL_MATERIAL_CATEGORIES_ADD_NEW: 'global_material_categories_add_new',
  GLOBAL_MATERIAL_CATEGORIES_EDIT: 'global_material_categories_edit',
  GLOBAL_CATEGORIES_DELETE: 'global_material_categories_delete',
  GLOBAL_MATERIAL_SUB_CATEGORIES_DELETE:
    'global_material_sub_categories_delete',
  GLOBAL_MATERIAL_SUB_CATEGORIES_EDIT: 'global_material_sub_categories_edit',
  GLOBAL_MATERIAL_SUB_CATEGORIES_ADD_NEW:
    'global_material_sub_categories_add_new',

  GLOBAL_STOCKS_VIEW: 'global_stocks_view',
  GLOBAL_STOCKS_LOGS_VIEW: 'global_stocks_logs_view',
  GLOBAL_STOCKS_STAR: 'global_stocks_star',
  GLOBAL_STOCK_UPDATE: 'global_stocks_update',
  GLOBAL_STOCKS_UPDATE_USED_WASTE: 'global_stocks_update_used_waste',
  GLOBAL_STOCKS_UPDATE_SUBSTOCKS: 'global_stocks_update_substocks',
  GLOBAL_STOCKS_UPDATE_SUBSTOCKS_USED_WASTE:
    'global_stocks_update_substocks_used_waste',
  GLOBAL_STOCKS_UPDATE_MINRECORD_QUANTITY:
    'global_stocks_and_warehouse_update_minRecordQuantity',
  GLOBAL_STOCKS_EXPORT: 'global_stocks_export',
  GLOBAL_STOCKS_HOLD: 'global_stocks_hold',

  GLOBAL_MATERIALS_ITEMS_ADD_NEW: 'global_materials_items_add_new',
  GLOBAL_MATERIALS_ITEMS_EDIT: 'global_materials_items_edit',
  GLOBAL_MATERIALS_ITEMS_DELETE: 'global_materials_items_delete',
  GLOBAL_MATERIALS_ITEMS_AUTO_PO: 'global_materials_items_auto_po',
  GLOBAL_MI_DISPATCH_PO: 'global_mi_dispatch_po',

  ACCOUNTS_VIEW: 'global_accounts_view',
  MASTER_TASKS_VIEW: 'global_master_tasks_view',

  ROLES_VIEW: 'global_roles_view',
  GLOBAL_ADMIN_ADD_ROLE: 'global_add_role',
  GLOBAL_ADMIN_EDIT_ROLE: 'global_edit_role',

  GLOBAL_LOGISTICS_VIEW: 'global_logistics_view',
  GLOBAL_TASK_VIEW: 'global_task_view',

  MATERIALS_VIEW: 'global_materials_view',

  GLOBAL_LOGISTICS_CREATE: 'global_logistics_create',
  GLOBAL_LOGISTICS_DELETE: 'global_logistics_delete',
  GLOBAL_LOGISTICS_DETAILS_VIEW: 'global_logistics_details_view',
  GLOBAL_LOGISTICS_UPDATE: 'global_logistics_update',

  GLOBAL_ADD_LABOURER: 'global_add_labourer',
  GLOBAL_EDIT_LABOURER: 'global_edit_labourer',

  GLOBAL_MASTER_DELETE_TASK: 'global_master_delete_task',
  GLOBAL_MASTER_ADD_NEW_TASK: 'global_master_add_new_task',
  GLOBAL_MASTER_EDIT_TASK: 'global_master_edit_task',

  GLOBAL_PROFILE_EDIT: 'global_profile_edit',
  GLOBAL_CREATE_TASK: 'global_create_task',
  GLOBAL_DETAIL_VIEW_TASK: 'global_detail_view_task',
  GLOBAL_UPDATE_TASK: 'global_update_task',
  // GLOBAL_SUB_TASK: 'global_sub_task',

  EXPENSES_VIEW_ALL: 'expenses_view_all',
  EXPENSES_VIEW: 'expenses_view',
  EXPENSES_CREATE: 'expenses_create',
  EXPENSES_DELETE: 'expenses_delete',
  EXPENSES_UPDATE: 'expenses_update',
  EXPENSES_ADD_PAYMENT: 'expenses_add_payment',
  EXPENSES_EXPORT: 'expenses_export',

  //Attendance
  ATTENDANCE_LOCATION_VIEW: 'attendance_location_view',
  ATTENDANCE_SHIFTS_VIEW: 'attendance_shifts_view',
  ATTENDANCE_TIMECARD_VIEW: 'attendance_timecard_view',
  ATTENDANCE_REGISTER_VIEW: 'attendance_register_view',
  ATTENDANCE_MODIFY: 'attendance_modify',

  FIELD_ITEMS_VIEW_ALL: 'field_items_view_all',
  FIELD_ITEMS_CREATE: 'field_items_create',
  FIELD_ITEMS_USAGE_ADD: 'field_items_usage_add',
  FIELD_ITEMS_USAGE_DELETE: 'field_items_usage_delete',

  PENDING_ACTIONS_VIEW: 'pending_actions_view',

  REPORTS_VIEW_ALL: 'reports_view_all',
  REPORTS_DOWNLOAD: 'reports_download',

  //new 
  // GLOBAL_WAREHOUSE_VIEW: 'global_warehouse_view',  --existing
  // GLOBAL_WAREHOUSE_CREATE: 'global_warehouse_create',--existing
  // GLOBAL_WAREHOUSE_UPDATE: 'global_warehouse_update',--existing
  // GLOBAL_WAREHOUSE_DELETE: 'global_warehouse_delete',--existing
  // GLOBAL_TASK_ADD_SUB_TASK: 'global_task_add_sub_task',-- existing
  // GLOBAL_TASK_UPDATE_SUB_TASK: 'global_task_update_sub_task', --common
  // GLOBAL_TASK_CHECKLIST_VIEW: 'global_task_checklist_view', --not added for project
  GLOBAL_TASK_CHECKLIST_ADD: 'global_task_checklist_add',
  GLOBAL_TASK_CHECKLIST_UPDATE: 'global_task_checklist_update',
  GLOBAL_TASK_CHECKLIST_DELETE: 'global_task_checklist_delete',
  GLOBAL_TASK_DELETE: 'global_task_delete',
  GLOBAL_TASK_MARK_AS_COMPLETE: 'global_task_mark_as_complete',
  GLOBAL_TASK_RAISE_ISSUE: 'global_task_raise_issue',
  GLOBAL_TASK_EDIT_ISSUE: 'global_task_edit_issue',
  GLOBAL_TASK_ADD_COMMENT: 'global_task_add_comment',
  GLOBAL_TASK_FILE_UPLOAD: 'global_task_file_upload',
  GLOBAL_TASK_FILE_PREVIEW: 'global_task_file_preview',
  GLOBAL_TASK_FILE_DOWNLOAD: 'global_task_file_download',
  GLOBAL_TASK_FILE_DELETE: 'global_task_file_delete',
  GLOBAL_TASK_SUB_TASK_IMPORT: 'global_task_sub_task_import',
  GLOBAL_TASK_SUB_TASK_CREATE: 'global_task_sub_task_create',
  GLOBAL_TASK_SUB_TASK_DELETE: 'global_task_sub_task_delete',
 // GLOBAL_TASK_SUBTASK_DETAIL_VIEW: 'global_task_subtask_detail_view', --common
  // GLOBAL_TASK_SUBTASK_RAISE_ISSUE: 'global_task_subtask_raise_issue', --common
  // GLOBAL_TASK_SUBTASK_EDIT_ISSUE: 'global_task_subtask_edit_issue', --common
  // GLOBAL_TASK_SUBTASK_ADD_COMMENT: 'global_task_subtask_add_comment', --common
  // GLOBAL_TASK_SUB_TASK_FILE_UPLOAD: 'global_task_sub_task_file_upload', --common
  // GLOBAL_TASK_SUB_TASK_FILE_PREVIEW: 'global_task_sub_task_file_preview', --common
  // GLOBAL_TASK_SUB_TASK_FILE_DOWNLOAD: 'global_task_sub_task_file_download', --common
  // GLOBAL_TASK_SUB_TASK_FILE_DELETE: 'global_task_sub_task_file_delete', --common
  // GLOBAL_TASK_SUB_TASK_CHECKLIST_ADD: 'global_task_sub_task_checklist_add', --common
  // GLOBAL_TASK_SUB_TASK_CHECKLIST_EDIT: 'global_task_sub_task_checklist_edit', --common
  // GLOBAL_TASK_SUB_TASK_CHECKLIST_DELETE: 'global_task_sub_task_checklist_delete', --common
  // GLOBAL_TASK_SUB_TASK_VIEW_DETAILS: 'global_task_sub_task_view_details', --common
  GLOBAL_MI_RECIEVE_NOTES: 'global_mi_receive_notes',
  GLOBAL_MI_RETURN_EXCHANGE: 'global_MI_return_&_exchange',
  GLOBAL_MI_WHATSAPP: 'global_MI_whatsapp',
  GLOBAL_MI_DISPATCH_INVENTORY: 'global_MI_dispatch_inventory',
  // GLOBAL_MI_DESPATCH_PO: 'global_MI_despatch_po',
  GLOBAL_PO_RECIEVE_NOTES: 'global_po_receive_notes',
  GLOBAL_PO_RETURN_EXCHANGE: 'global_PO_return_&_exchange',
  GLOBAL_PO_WHATSAPP: 'global_PO_whatsapp',
  GLOBAL_LOGISTICS_RECEIVE_NOTES: 'global_logistics_receive_notes',
  GLOBAL_PO_CONVERT_TO_BILL: 'global_PO_convert_to_bill',
  GLOBAL_PO_BILLS_EXPORT: 'global_PO_bills_export',
  GLOBAL_PO_BILLS_SEND_WHATSAPP: 'PO_bills_send_whatsapp', //common 
  GLOBAL_PO_BILLS_PRINT: 'PO_bills_print', //common
  GLOBAL_PO_BILLS_ADD_PAYMENTS: 'PO_bills_add_payments',//common
  GLOBAL_PO_BILLS_PAYMENTS_DETAIL_VIEW: 'PO_bills_payments_detail_view',//common
  GLOBAL_PO_BILLS_PAYMENTS_STATUS: 'PO_bills_payments_status',//common
  GLOBAL_EXPENSES_VIEW: 'global_Expenses_view',
  GLOBAL_EXPENSES_OVERVIEW: 'global_Expenses_overview',
  GLOBAL_EXPENSES_PAYMENTS: 'global_Expenses_payments',
  GLOBAL_EXPENSES_FILES: 'global_Expenses_files',
  GLOBAL_EXPENSES_APPROVE_AND_REJECT: 'global_Expenses_approve_and_reject',
  GLOBAL_EXPENSES_FILES_PREVIEW: 'global_Expenses_files_preview',
  GLOBAL_EXPENSES_FILES_DOWNLOAD: 'global_Expenses_files_download',
  GLOBAL_EXPENSES_FILES_DELETE: 'global_Expenses_files_delete',
  GLOBAL_EXPENSES_ADD_ADVANCE: 'global_Expenses_add_advance',
  GLOBAL_EXPENSES_ADVANCE_VIEW: 'global_Expenses_advance_view',
  GLOBAL_EXPENSES_ADVANCE_DETAIL_VIEW: 'global_Expenses_advance_detail_view',
  GLOBAL_ATTENDENCE_MYPAYSLIP_VIEW: 'global_attendance_mypayslip_view',
  GLOBAL_ATTENDENCE_PAYSLIP_VIEW: 'global_attendance_payslip_view',
  GLOBAL_ATTENDENCE_LEAVE_MANAGEMENT_VIEW: 'global_attendance_leave_management_view',
  GLOBAL_ATTENDENCE_LEAVE_MANAGEMENT_MANAGE_LEAVES: 'global_attendance_leave_management_manage_leaves',
  GLOBAL_ATTENDENCE_LEAVE_REQUEST_MANAGEMENT: 'global_attendence_leave_request_management', 
  // GLOBAL_ATTENDENCE_APPLY_LEAVE_VIEW: 'global_attendence_apply_leave_view', --not required
  // GLOBAL_ATTENDENCE_COMPANY_LEAVES_VIEW: 'global_attendence_company_leaves_view',--not required
  // GLOBAL_fields_item_usage_view: 'global_fields_item_usage_view',--  existing
  // GLOBAL_roles_detail_view: 'global_roles_detail_view',--  existing
  // GLOBAL_edit_role: 'global_edit_role',--  existing
  GLOBAL_CONFIGURATION_VIEW: 'global_configuration_view',
  GLOBAL_CRM_LEADS_VIEW_DETAILS: 'global_CRM_leads_view_details',
  GLOBAL_CRM_LEADS_MOVE_LEAD: 'global_CRM_leads_move_lead',
  GLOBAL_CRM_LEADS_BULK_UPLOAD: 'global_CRM_leads_bulk_upload',
};

const PRIVILEGES = {
  PROJECT: PROJECT_PRIVILEGES,
  APPROVAL: APPROVAL_PRIVILEGES,
  COMMON: COMMON_PRIVILEGES,
};

export default PRIVILEGES;
